<script>
export default {
  components: {},
  methods:{
    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CF':
          result = 'Conferido'
          break
        case 'CN':
          result = 'Conectado'
          break
        case 'CO':
          result = 'Confirmado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'EC':
          result = 'Encerrado'
          break
        case 'ES':
          result = 'Em Separação'
          break
        case 'EX':
          result = 'Expirado'
          break
        case 'FE':
          result = 'Fechado'
          break
        case 'EQ':
          result = 'Embarque'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'FN':
          result = 'Finalizado'
          break
        case 'NC':
          result = 'Não Conectado'
          break
        case 'SE':
          result = 'Conferido'
          break
        case 'PR':
          result = 'Em Produção'
          break
        case 'A':
          result = 'Ativo'
          break
        case 'I':
          result = 'Inativo'
          break
        case 'paid':
          result = 'Pago'
          break

        case 'CP':
          return 'Conf. Parcial (CP)'
        case 'NEM':
          return 'Nota Fiscal Emitida (NEM)'
        case 'NLO':
          return 'Não Encontrado (NLO)'
        case 'ENP':
          return 'Entregue no Prazo (ENP)'
        case 'ECR':
          return 'Entregue com Ressalva (ECR)'
        case 'EAT':
          return 'Entregue com Atraso (EAT)'
        case 'CCT':
          return 'Com CTe (CCT)'
        case 'TRA':
          return 'Transferido (TRA)'
        case 'CAN':
          return 'Cancelado (CAN)'


        case 'COL':
          return 'Conciliado (COL)'


        case 'SCT':
          return 'Sem CTe'
        case 'NEP':
          return 'Dentro do Prazo (Não Entregue)'
        case 'NEF':
          return 'Fora do Prazo (Não Entregue)'

        case 'INS':
            return 'Insucesso de entrega (INS)'
        default:
          result = stsIn
      }
      return result
    },
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    status: {
      type: String,
      default: ''
    }
  },
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0 font-size-18">{{ title }}

          <span v-if="status"
                class="badge badge-pill badge-soft-success font-size-11"
                :class="status === 'EL' ? 'badge-soft-warning'
                : status === 'AB' ? 'badge-soft-warning'
                : status === 'EQ' ? 'badge-soft-warning'
                : status === 'EC' ? 'badge-soft-success'
                : status === 'ENP' ? 'badge-soft-success'
                : status === 'ES' ? 'badge-soft-warning'
                : status === 'EX' ? 'badge-soft-warning'
                : status === 'COL' ? 'badge-soft-success'
                : status === 'CCT' ? 'badge-soft-info'
                : status === 'NEM' ? 'badge-soft-info'
                : status === 'PR' ? 'badge-soft-warning'
                : status === 'A' ? 'badge-soft-success'
                : status === 'CF' ? 'badge-soft-success'
                : status === 'CN' ? 'badge-soft-success'
                : status === 'SE' ? 'badge-soft-success'
                : status === 'FE' ? 'badge-soft-success'
                : status === 'CO' ? 'badge-soft-info'
                : status === 'FA' ? 'badge-soft-success'
                : status === 'NC' ? 'badge-soft-danger'
                : status === 'FN' ? 'badge-soft-success'
                : status === 'CP' ? 'badge-soft-info'
                : status === 'paid' ? 'badge-soft-success'
                : status === 'AT' ? 'badge-soft-success'
                : status === 'PD' ? 'badge-soft-success'
                : status === 'PG' ? 'badge-soft-success'
                : status === 'NG' ? 'badge-soft-warning'
                : 'badge-soft-info'">

                {{ nomeStatus(status)  }}
              </span>
        </h4>



        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
